import Vue from "vue";
import Vuex from "vuex";
import { userLogin, userLogOut, keyCloakLogin, clearNotification } from "@/utils/login/apiFunctions";
import { resetRouter } from "@/router";
import { setToken, clearCookies, checkAndSetCookies, getRefreshToken, getToken, getMobileToken } from "@/utils/login/tokenCheck";
const qs = require("qs");
Vue.use(Vuex);

// State
const state = () => ({
  token: "",
  refreshToken: "",
  panelID: "",
  ticketFilters: {},
  objectInfo: {},
  closingRemarks: {},
});

// getters
const getters = {
  getUserToken: (state) => state.token,
  getUserRefreshToken: (state) => state.refreshToken,
  getPanelID: (state) => state.panelID,
  getTicketFilters: (state) => state.ticketFilters,
  getObjectInfo: (state) => state.objectInfo,
  getClosingRemarks: (state) => state.closingRemarks,
};

// actions
const actions = {
  // Login Api
  Login({ commit }, userInfo) {
    return new Promise((resolve, reject) => {
      userLogin(userInfo.keycloak, {
        "content-type": "application/x-www-form-urlencoded;charset=utf-8",
      })
        .then(async (response) => {
          const data = response.data;
          if (data && data.access_token && data.refresh_token) {
            const res = await keyCloakLogin(data.access_token);
            checkAndSetCookies(res.data.details);
            setToken(data.access_token, data.refresh_token);
            commit("SET_TOKEN", data.access_token);
            commit("SET_REFRESH_TOKEN", data.refresh_token);
            resolve(response);
          } else {
            reject("Tokens not found in response");
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  // LogOut Api
  LogOut(state) {
    resetRouter();
    userLogOut(
      qs.stringify({
        client_id: "vue-test-app",
        refresh_token: getRefreshToken(),
      }),
      {
        "content-type": "application/x-www-form-urlencoded;charset=utf-8",
        Authorization: `Bearer ${getToken()}`,
      }
    )
      .then(async (response) => {
				if(getMobileToken()) await clearNotification({token: getMobileToken()});
        localStorage.clear();
        clearCookies();
        state.commit("SET_TOKEN", "");
        state.commit("SET_REFRESH_TOKEN", "");
        window.location.replace(
          `https://admin.hire3x.com/login`
        );
        return response;
      })
      .catch(async (error) => {
        if(getMobileToken()) await clearNotification({token: getMobileToken()});
        localStorage.clear();
        clearCookies();
        state.commit("SET_REFRESH_TOKEN", "");
        state.commit("SET_TOKEN", "");
        window.location.replace(
          `https://admin.hire3x.com/login`
        );
        return error;
      });
  },
};

// mutations
const mutations = {
  // Storing Token
  SET_TOKEN(state, token) {
    state.token = token;
  },
  // Storing Refresh Token
  SET_REFRESH_TOKEN(state, refreshToken) {
    state.refreshToken = refreshToken;
  },
  //Storing panelid
  SET_PANEL_ID(state, data) {
    state.panelID = data;
  },
  SET_TICKET_FILTERS(state, filters) {
    state.ticketFilters = filters;
    // Persist to sessionStorage so it survives page refresh
    if (filters && Object.keys(filters).length > 0) {
      sessionStorage.setItem('ticketFilters', JSON.stringify(filters));
    } else {
      sessionStorage.removeItem('ticketFilters');
    }
  },
  SHOW_HIDE_REVIEW_CARD(state, data) {
    state.objectInfo = data;
  },
  SET_CLOSING_REMARKS(state, data) {
    state.closingRemarks = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
